/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react';
import { getProxiedServiceUrl, getProxyURLforDocumentDetail } from 'gw-portals-url-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import { JsonRPCService } from 'gw-portals-transport-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import { DocumentUploadService } from 'gw-portals-document-js';
import _ from 'lodash';
import { attempt } from 'lodash';
import UtilService from './UtilService';
// eslint-disable-next-line no-warning-comments
// US-OSBC-215 <exposed the methods to fetch account-claim releated informations for specific user>
class ClaimService {
    static claimFeatures = {
        claimUploadDocumentFeatureEnabled: true,
        claimSecureMessagingFeatureEnabled: true,
        claimDocumentHistoryFeatureEnabled: true,
        claimRelatedDocumentFeatureEnabled: true,
        claimBenefitPaymentsFeatureEnabled: true,
        claimHealthCareBenefitsFeatureEnabled: true,
        claimNonHealthCareBenefitsFeatureEnabled: true,
        claimSummariesFeatureEnabled: true,
        claimEnrollmentFeatureEnabled: true,
        claimAppealsFeatureEnabled: true
    };

    static getAuthHeader() {
        let accessToken = document
            .getElementsByTagName('html')[0]
            .getAttribute('authheader');
        accessToken = accessToken
            ? {
                Authorization: `Bearer ${accessToken}`,
                'ocp-apim-subscription-key': UtilService.getSubscriptionKey()
            }
            : undefined;
        return accessToken;
    }

    static getOAAuthHeader() {
        let accessToken = document
            .getElementsByTagName('html')[0]
            .getAttribute('authheader');
        accessToken = accessToken
            ? {
                Authorization: `Bearer ${accessToken}`,
                'ocp-apim-subscription-key': UtilService.getOASubscriptionKey()
            }
            : undefined;
        return accessToken;
    }

    static getClaimSummaries(query, offset, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimSummaries_WSIB', [query, offset], this.getAuthHeader());
    }

    static getClaimSubmittedDocuments(claimNUmber, serviceName = 'claim', additionalHeaders = {}, paginationConfig = null) {
        const params = [claimNUmber];
        const cfg = paginationConfig || {
            offset: 0,
            limit: 10,
            orderBy: null,
            orderByDescending: null,
            documentSearchCriteria: null
        };
        const offset = cfg.offset ?? 0;
        const limit = cfg.limit ?? 10;
        params.push({
            offsetstart: offset,
            offsetend: offset + limit - 1,
            orderBy: cfg.orderBy ?? null,
            orderByDescending: cfg.orderByDescending ?? null,
            documentSearchCriteria: cfg.documentSearchCriteria ?? null
        });
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getOSPCClaimSubmittedDocuments_WSIB', params, { ...this.getAuthHeader(), ...additionalHeaders });
    }

    static getAllClaimRelatedDocuments(claimNUmber, serviceName = 'claim', additionalHeaders = {}, paginationConfig = null) {
        const params = [claimNUmber];
        const cfg = paginationConfig || {
            offset: 0,
            limit: 10,
            orderBy: null,
            orderByDescending: null,
            documentSearchCriteria: null
        };
        const offset = cfg.offset ?? 0;
        const limit = cfg.limit ?? 10;
        params.push({
            offsetstart: offset,
            offsetend: offset + limit - 1,
            orderBy: cfg.orderBy ?? null,
            orderByDescending: cfg.orderByDescending ?? null,
            documentSearchCriteria: cfg.documentSearchCriteria ?? null
        });
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getOSPCAllClaimSubmittedDocuments_WSIB', params, { ...this.getAuthHeader(), ...additionalHeaders });
    }

    static getClaimDocumentDetail(document, serviceName, showDescriptionModal, hasLinkedDoc = false, source = '') {
        const endpointUrl = getProxyURLforDocumentDetail(serviceName, document);
        return this.getClaimDocument(endpointUrl, this.getAuthHeader(), showDescriptionModal, document, hasLinkedDoc, source);
    }

    static getClaimDocument(downloadEndpointURL, authHeader, errorCallback = _.noop, documentData, hasLinkedDoc = false, source = '') {
        const params = {
            method: 'GET',
            url: downloadEndpointURL,
            headers: {
                ...authHeader
            },
        };
        return fetch(downloadEndpointURL, params).then((response) => {
            if (response.ok) {
                // SUCCESS: read blob
                return response.blob().then((blob) => ({ response, blob }));
            }

            // throw error based on error type
            const ct = response.headers.get('Content-Type') || '';

            if (ct.toLowerCase().includes('application/json')) {
                // Always read as text first if failed it will go to catch block
                return response.text().then((text) => {
                    let message = 'Other Errors';
                    try {
                        const json = JSON.parse(text);
                        message = json?.message || JSON.stringify(json);
                    } catch (e) {
                        // backend sent plain text with wrong content-type
                        message = text || message;
                    }

                    throw new Error(message);
                });
            }
            return response.text().then((text) => {
                throw text;
            });
        })
            .then(({ response, blob }) => {
                const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    let testBlob;
                    // const blob = new Blob(['Hello, I am Blob content'], { type: 'drs/xlsx' });
                    if (blob.type === 'drs/docx' || blob.type === 'drs/doc') {
                        console.log(' in doc');
                        testBlob = blob.slice(0, blob.size, 'application/msword');
                    }
                    if (blob.type === 'drs/xls' || blob.type === 'drs/xlsx') {
                        console.log(' in xlsx');
                        testBlob = blob.slice(0, blob.size, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                    if (blob.type === 'drs/pdf') {
                        console.log(' in pdf');
                        testBlob = blob.slice(0, blob.size, 'application/pdf');
                    }
                    console.log('myBlob', testBlob);
                    console.log('blob', blob);
                    const updatedBlob = testBlob || blob;
                    console.log('updated blob', updatedBlob);
                    const downloadLink = document.createElement('a');
                    downloadLink.setAttribute('href', window.URL.createObjectURL(updatedBlob));
                    downloadLink.setAttribute('download', filename);
                    downloadLink.style.display = 'none';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    // downloadLink.remove();
                    const blobURL = window.URL.createObjectURL(updatedBlob);
                    URL.revokeObjectURL(blobURL);
                }
            }).catch((err) => {
                const errorMessage = err?.message || err;
                if (errorMessage?.toLowerCase() === 'document not found') {
                    throw new Error('UNPUBLISHEDDOCERR');
                }

                if (errorMessage.includes('406')) {
                    if (hasLinkedDoc) {
                        if (source === '') {
                            errorCallback('DOCSCRUBMSG41_2');
                        } else {
                            errorCallback('DOCSCRUBMSG41_1');
                        }
                    } else {
                        errorCallback('DOCSCRUBMSG40');
                    }
                    return false;
                }

                if (hasLinkedDoc) {
                    if (source === 'MAIN_DOC_DOWNLOAD') {
                        errorCallback('TWODOCDOWNLOADFAIL');
                        return false;
                    }
                    return errorCallback('TWODOCDOWNLOADFAIL');
                }

                throw new Error('SINGALDOCDOWNLOADFAIL');
            });
    }

    static getClaimRelatedDocumentDetail(document, serviceName, showDescriptionModal, readUnreadTrackerCallback) {
        const endpointUrl = getProxyURLforDocumentDetail(serviceName, document);
        return this.getClaimRelatedDocument(endpointUrl, this.getAuthHeader(), showDescriptionModal, document, readUnreadTrackerCallback);
    }

    static getClaimRelatedDocument(downloadEndpointURL, authHeader, errorCallback = _.noop, documentData, readUnreadTrackerCallback) {
        const params = {
            method: 'GET',
            url: downloadEndpointURL,
            headers: {
                ...authHeader
            },
        };
        return fetch(downloadEndpointURL, params).then((response) => {
            if (response.ok) {
                // SUCCESS: read blob
                return response.blob().then((blob) => ({ response, blob }));
            }

            // throw error based on error type
            const ct = response.headers.get('Content-Type') || '';

            if (ct.toLowerCase().includes('application/json')) {
                // Always read as text first if failed it will go to catch block
                return response.text().then((text) => {
                    let message = 'Other Errors';
                    try {
                        const json = JSON.parse(text);
                        message = json?.message || JSON.stringify(json);
                    } catch (e) {
                        // backend sent plain text with wrong content-type
                        message = text || message;
                    }

                    throw new Error(message);
                });
            }
            return response.text().then((text) => {
                throw text;
            });
        })
            .then(async ({ response, blob }) => {
                const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');

                try {
                    await readUnreadTrackerCallback(documentData);
                } catch (err) {
                    console.log('Read/unread tracker failed silently', err);
                }

                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    let testBlob;
                    // const blob = new Blob(['Hello, I am Blob content'], { type: 'drs/xlsx' });
                    if (blob.type === 'drs/docx' || blob.type === 'drs/doc') {
                        console.log(' in doc');
                        testBlob = blob.slice(0, blob.size, 'application/msword');
                    }
                    if (blob.type === 'drs/xls' || blob.type === 'drs/xlsx') {
                        console.log(' in xlsx');
                        testBlob = blob.slice(0, blob.size, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                    if (blob.type === 'drs/pdf') {
                        console.log(' in pdf');
                        testBlob = blob.slice(0, blob.size, 'application/pdf');
                    }
                    console.log('myBlob', testBlob);
                    console.log('blob', blob);
                    const updatedBlob = testBlob || blob;
                    console.log('updated blob', updatedBlob);
                    const downloadLink = document.createElement('a');
                    downloadLink.setAttribute('href', window.URL.createObjectURL(updatedBlob));
                    downloadLink.setAttribute('download', filename);
                    downloadLink.style.display = 'none';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    // downloadLink.remove();
                    const blobURL = window.URL.createObjectURL(updatedBlob);
                    URL.revokeObjectURL(blobURL);
                }
            }).catch((err) => {
                const errorMessage = err?.message || err;
                throw new Error(errorMessage);
            });
    }

    static getMultiDownloadClaimDocumentDetail(document, serviceName, showDescriptionModal) {
        const endpointUrl = getProxyURLforDocumentDetail(serviceName, document);
        return this.getMultiDownloadClaimDocument(endpointUrl, this.getAuthHeader(), showDescriptionModal, document);
    }

    static getMultiDownloadClaimDocument(downloadEndpointURL, authHeader, errorCallback = _.noop, documentData) {
        const params = {
            method: 'GET',
            url: downloadEndpointURL,
            headers: {
                ...authHeader
            },
        };
        return fetch(downloadEndpointURL, params).then((response) => {
            if (response.ok) {
                // SUCCESS: read blob
                return response.blob().then((blob) => ({ response, blob }));
            }

            // throw error based on error type
            const ct = response.headers.get('Content-Type') || '';

            if (ct.toLowerCase().includes('application/json')) {
                // Always read as text first if failed it will go to catch block
                return response.text().then((text) => {
                    let message = 'Other Errors';
                    try {
                        const json = JSON.parse(text);
                        message = json?.message || JSON.stringify(json);
                    } catch (e) {
                        // backend sent plain text with wrong content-type
                        message = text || message;
                    }

                    throw new Error(message);
                });
            }
            return response.text().then((text) => {
                throw text;
            });
        })
            .then(({ response, blob }) => {
                const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    let testBlob;
                    // const blob = new Blob(['Hello, I am Blob content'], { type: 'drs/xlsx' });
                    if (blob.type === 'drs/docx' || blob.type === 'drs/doc') {
                        console.log(' in doc');
                        testBlob = blob.slice(0, blob.size, 'application/msword');
                    }
                    if (blob.type === 'drs/xls' || blob.type === 'drs/xlsx') {
                        console.log(' in xlsx');
                        testBlob = blob.slice(0, blob.size, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                    if (blob.type === 'drs/pdf') {
                        console.log(' in pdf');
                        testBlob = blob.slice(0, blob.size, 'application/pdf');
                    }
                    console.log('myBlob', testBlob);
                    console.log('blob', blob);
                    const updatedBlob = testBlob || blob;
                    console.log('updated blob', updatedBlob);
                    const downloadLink = document.createElement('a');
                    downloadLink.setAttribute('href', window.URL.createObjectURL(updatedBlob));
                    downloadLink.setAttribute('download', filename);
                    downloadLink.style.display = 'none';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    // downloadLink.remove();
                    const blobURL = window.URL.createObjectURL(updatedBlob);
                    URL.revokeObjectURL(blobURL);
                }
            }).catch((err) => {
                const errorMessage = err?.message || err;
                if (errorMessage?.toLowerCase() === 'document not found') {
                    throw new Error('UNPUBLISHEDDOCERR');
                }
                if (!_.isEmpty(documentData.coverLettersDetails)) {
                    return errorCallback('TWODOCDOWNLOADFAIL');
                }
                return errorCallback(errorMessage);
            });
    }

    static getMultiDownloadClaimRelatedDocumentDetail(document, serviceName, showDescriptionModal) {
        const endpointUrl = getProxyURLforDocumentDetail(serviceName, document);
        return this.getMultiDownloadClaimRelatedDocument(endpointUrl, this.getAuthHeader(), showDescriptionModal, document);
    }

    static getMultiDownloadClaimRelatedDocument(downloadEndpointURL, authHeader, errorCallback = _.noop, documentData) {
        const params = {
            method: 'GET',
            url: downloadEndpointURL,
            headers: {
                ...authHeader
            },
        };
        return fetch(downloadEndpointURL, params).then((response) => {
            if (response.ok) {
                // SUCCESS: read blob
                return response.blob().then((blob) => ({ response, blob }));
            }

            // throw error based on error type
            const ct = response.headers.get('Content-Type') || '';

            if (ct.toLowerCase().includes('application/json')) {
                // Always read as text first if failed it will go to catch block
                return response.text().then((text) => {
                    let message = 'Other Errors';
                    try {
                        const json = JSON.parse(text);
                        message = json?.message || JSON.stringify(json);
                    } catch (e) {
                        // backend sent plain text with wrong content-type
                        message = text || message;
                    }

                    throw new Error(message);
                });
            }
            return response.text().then((text) => {
                throw text;
            });
        })
            .then(({ response, blob }) => {
                const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    let testBlob;
                    // const blob = new Blob(['Hello, I am Blob content'], { type: 'drs/xlsx' });
                    if (blob.type === 'drs/docx' || blob.type === 'drs/doc') {
                        console.log(' in doc');
                        testBlob = blob.slice(0, blob.size, 'application/msword');
                    }
                    if (blob.type === 'drs/xls' || blob.type === 'drs/xlsx') {
                        console.log(' in xlsx');
                        testBlob = blob.slice(0, blob.size, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                    if (blob.type === 'drs/pdf') {
                        console.log(' in pdf');
                        testBlob = blob.slice(0, blob.size, 'application/pdf');
                    }
                    console.log('myBlob', testBlob);
                    console.log('blob', blob);
                    const updatedBlob = testBlob || blob;
                    console.log('updated blob', updatedBlob);
                    const downloadLink = document.createElement('a');
                    downloadLink.setAttribute('href', window.URL.createObjectURL(updatedBlob));
                    downloadLink.setAttribute('download', filename);
                    downloadLink.style.display = 'none';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    // downloadLink.remove();
                    const blobURL = window.URL.createObjectURL(updatedBlob);
                    URL.revokeObjectURL(blobURL);
                }
            }).catch((err) => {
                const errorMessage = err?.message || err;
                throw new Error(errorMessage);
            });
    }

    static getWorkerDetails(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getWorkerDetails_WSIB', [claimNumber], this.getAuthHeader());
    }

    static updateContactAddress(claimNumber, mailingAddress, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'updateContactAddress', [claimNumber, mailingAddress], this.getAuthHeader());
    }

    static updatePhoneNumber(claimNumber, phoneNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'updatePhoneNumber', [claimNumber, phoneNumber], this.getAuthHeader());
    }

    static unLockDirectDeposit(serviceName, pinNumber, claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'unLockDirectDeposit', [pinNumber, claimNumber], this.getAuthHeader());
    }

    static savePinFailure(serviceName, claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'savePinFailureEvent', [claimNumber], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getClaimDetails(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getWorkerClaimDetail_WSIB', [params], this.getAuthHeader());
    }

    /*
     * @param {string} claimNumber
     * @param {string} employeeLastName
     * @param {object} additionalHeaders
     * @returns claim Details
     * fetch claim details
     */
    static getSearchClaimDetails(param, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getSearchClaimDetail_WSIB', [param], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getPaymentDetails(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimBenefitPayments_WSIB', [params], this.getAuthHeader());
    }

    /*
    * @param {string} params
    * @param {object} authheader
    * @returns generateToken for document upload
    */

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'generateUploadToken',
            params, additionalHeaders);
    }

    /*
    * @param {file} file
    * @param {object} documentMetadata
    * @param {object} additionalHeaders
    * @returns submit document
    */
    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('claimDocumentUpload'),
            file, documentMetadata, this.getAuthHeader());
    }

    // ospcchange to delete submitted document item for DI (Dynamic intake) project
    static deleteDocument(parameter, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'removeDocument_WSIB',
            parameter, additionalHeaders);
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getHealthCareDetails(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimHealthCareBenefits_WSIB', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getNonHealthCareDetails(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimNonHealthCareBenefits_WSIB', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getAppealsDetails(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimAppeals_WSIB', [params], this.getAuthHeader());
    }

    /*
     * @param {string} claim number
     * @returns claim Details
     * fetch direct deposit details
     */
    static getDirectDepositInfo(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getClaimDirectDeposit', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * verify direct deposit dob
     */
    static directDepositVerifyDob(claimNumber, month, year, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'verifyDob', [claimNumber, month, year], this.getAuthHeader());
    }

    static validateDDSeurityQuestion(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'validatePersonalidQuestions', params, this.getAuthHeader());
    }

    static personalIDQuestionsLockStatus(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'personalIDQuestionsLockStatus', params, this.getAuthHeader());
    }

    static getUserPersonalIDQuestions(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getUserPersonalIDQuestions', [params], this.getAuthHeader());
    }

    static directDepositFailureToServer(serviceName, claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'createHistoryForAuthFailure', [claimNumber], this.getAuthHeader());
    }

    /* sample request
    {
        "id":"a81a3f5e-65e9-4353-a03f-edf3c5679655_13",
        "jsonrpc":"2.0",
        "method":"getBankInfo",
        "params":
        [
            "0010",
            "00502"
        ]
    }

    //sample response
    {
        "id":"a81a3f5e-65e9-4353-a03f-edf3c5679655_13",
        "result":"CANADIAN IMPERIAL BANK OF COMMERCE\nSSNTS & MMSSQ MHNHUNT DSNDQS\n2 BLOOR ST. W.\n2 BLOOR ST. W.\nTORONTO, ON, M5V 3J1",
        "jsonrpc":"2.0"
    }
*/
    static directDepositVerifyBankInfo(serviceName, transitNumber, institutionNumber, additionalHeaders = {}) {
        const fullInstNumber = `0${institutionNumber}`;
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getBankInfo', [fullInstNumber, transitNumber], this.getAuthHeader());
    }

    /* sample request for add bank info
    {
        "id":"a81a3f5e-65e9-4353-a03f-edf3c5679655_8",
        "jsonrpc":"2.0",
        "method":"updateDirectDepositBankInfo",
        "params":
        [{
            "bankAccountNumber":"1234567",
            "wsibbankNumber":"0010",
            "wsibbranchNumber":"00502",
            "claimNumber":"31430007"
        }]
    }

    sample request for edit bank info
    {
        "id":"a81a3f5e-65e9-4353-a03f-edf3c5679655_14",
        "jsonrpc":"2.0",
        "method":"updateDirectDepositBankInfo",
        "params":
        [{
            "bankAccountNumber":"12345678",
            "wsibbankNumber":"0010",
            "wsibbranchNumber":"00502",
            "publicID":"cc:1012094",
            "claimNumber":"31430007"
        }]
    }

    sample response for add bank info of success
    {
        "id":"a81a3f5e-65e9-4353-a03f-edf3c5679655_8",
        "result":"true",
        "jsonrpc":"2.0"
    }
*/
    static updateDirectDepositInfo(serviceName, bankinformation, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'updateDirectDepositBankInfo', [bankinformation], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch direct deposit account status
     */
    static getDirectDepositAccountStatus(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getUserAccountStatus', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch claim details
     */
    static getMessageList(params, additionalHeaders = {}) {
        const serviceName =  UtilService.getServiceName('customerMessage');
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getMessagesForCustomer', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * save message
     */
    static saveMessage(params, additionalHeaders = {}) {
        const serviceName =  UtilService.getServiceName('customerMessage');
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'saveMessage', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * message count
     */
    static messageCount(params, additionalHeaders = {}) {
        const serviceName =  UtilService.getServiceName('customerMessage');
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getNewMessageCount', [params], this.getAuthHeader());
    }

    /*
     * @param {string} params
     * get Message Thread
     */
    static getMessageThread(params, additionalHeaders = {}) {
        const serviceName =  UtilService.getServiceName('customerMessage');
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getMessageThread', params, this.getAuthHeader());
    }

    /*
     * @param {string} params
     * get Message Thread
     */
    static getTombstoneData(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getTombstoneDetail_WSIB', [params], this.getAuthHeader());
    }

    static getAccountFilterData(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getAccountFilterList_WSIB', params, this.getAuthHeader());
    }

    static getActiveClaims(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getActiveClaimSummaries_WSIB', params, this.getAuthHeader());
    }

    static getFilterClaims(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimAdvanceSearchSummary_WSIB', params, this.getAuthHeader());
    }

    static getArchiveClaims(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getArchiveClaimSummaries_WSIB', params, this.getAuthHeader());
    }

    static getFilterClaimsClaimNo(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimSummariesByClaimNumber_WSIB', params, this.getAuthHeader());
    }

    static canEnrollClaim(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('enrollment'),
            'validateNewUser', [params], this.getAuthHeader());
    }

    static addWorkerEnrollmentRecord(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('enrollment'),
            'addWorkerEnrollmentRecord_WSIB', [params], this.getAuthHeader());
    }

    static createOSPCDocumentReadTracker(serviceName, params) {
        return JsonRPCService.send(
            getProxiedServiceUrl(serviceName),
            'createOSPCDocumentReadTracker_WSIB',
            [params],
            this.getAuthHeader()
        );
    }

    static getOSPCAllClaimHistoricalDocumentsWSIB(params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'processAllClaimHistoricalDocs_WSIB',
            [params, 'OSPC'],
            this.getAuthHeader()
        );
    }

    static addPWIEnrollmentRecord_WSIB(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('enrollment'),
            'addPWIEnrollmentRecord_WSIB', [params], this.getAuthHeader());
    }

    static getUnEnrolledClaimsList(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'getUnEnrolledClaimsList', params, this.getAuthHeader());
    }

    static generateClaimPIN(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'generatePinNumber', params, this.getAuthHeader());
    }

    static getNotifications(serviceName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'retrieveNotifications', [], this.getOAAuthHeader());
    }

    static getUnreadCount(serviceName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'retrieveUnreadCount', [], this.getOAAuthHeader());
    }

    static getUserInfo(params) {
        return JsonRPCService.send(getProxiedServiceUrl('userdetails'),
            'retrieveUserDetail', [params], this.getAuthHeader());
    }

    static cancelTheClaimApplication(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'cancelPinNumber', params, this.getAuthHeader());
    }


    static updateNotificationsAsRead(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'updateNotificationsAsRead', [params], this.getOAAuthHeader());
    }

    static updateNotificationStatus(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'updateNotificationStatus', [params], this.getOAAuthHeader());
    }

    static claimPinValidation(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'validatePinNumber', params, this.getAuthHeader());
    }

    static checkClaimNumberStatus(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimPin'),
            'validatePinResentStatus', params, this.getAuthHeader());
    }

    static updateNotificationAsUnread(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'updateNotificationAsUnread', [params], this.getOAAuthHeader());
    }

    static getSecurityQuestions(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'retrieveSecurityQuestions', params, this.getOAAuthHeader());
    }

    static validateSecurityQuestions(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'validateAnswers', params, this.getOAAuthHeader());
    }

    static validateAndRetrieveSecurityQuestions(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'validateAndRetrieveSecurityQuestions', params, this.getOAAuthHeader());
    }

    static getPIQLockoutStatus(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getUserLockoutInfoForPopup', params, this.getOAAuthHeader());
    }

    static getProfileStatus(serviceName, params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(serviceName),
            'getTelephoneDetails', [params], this.getAuthHeader());
    }
}

class MockClaimService extends ClaimService {
    static getClaimSummaries(query, offset, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('claim'),
        //     'getClaimSummaries_WSIB', [query, offset], this.getAuthHeader());
        const okData = {
            id: 'd9b4985b-ffd0-4651-aa4b-a4b51067cc80_1',
            result: {
                items: [
                    {
                        publicID: 'cc:4001',
                        claimNumber: '30000020',
                        lossDate: '2022-02-17T04:44:47Z',
                        claimState: 'open',
                        entitlementStatus_WSIB: 'Allowed',
                        employer_WSIB: 'IBM',
                        pinStatus: {
                            PinRequestDate: '04-06-2025 23:55',
                            Status: 'started'
                        }
                    },
                    {
                        publicID: 'cc:101',
                        claimNumber: '30000003',
                        lossDate: '2017-12-30T03:19:17Z',
                        claimState: 'open',
                        entitlementStatus_WSIB: 'Pending',
                        employer_WSIB: 'MINAS CORP LTD CANADA',
                        pinStatus: {
                        }
                    },
                    {
                        publicID: 'cc:201',
                        claimNumber: '30000008',
                        lossDate: '2017-12-29T18:37:17Z',
                        claimState: 'open',
                        entitlementStatus_WSIB: 'Allowed',
                        employer_WSIB: 'MINAS CORP LTD CANADA',
                        pinStatus: {
                            PinRequestDate: '04-06-2025 23:55',
                            Status: 'started'
                        }
                    },
                    {
                        publicID: 'cc:301',
                        claimNumber: '30000015',
                        lossDate: '2017-12-23T15:46:34Z',
                        claimState: 'open',
                        entitlementStatus_WSIB: 'Allowed',
                        employer_WSIB: 'MINAS CORP LTD CANADA',
                        pinStatus: {
                            PinRequestDate: '04-06-2025 23:55',
                            Status: 'started'
                        }
                    },
                    {
                        publicID: 'cc:401',
                        claimNumber: '30000016',
                        lossDate: '2017-12-19T21:01:55Z',
                        claimState: 'open',
                        entitlementStatus_WSIB: 'Allowed',
                        employer_WSIB: 'MINAS CORP LTD CANADA',
                        pinStatus: {
                        }
                    }
                ],
                maxNumberOfResults: 5,
                claimArchived_WSIB: false,
                claimFeatures_WSIB: {
                    formFieldContentDecodedEncodedKeywords: 'or:ro,OR:RO,Or:Ro,AND:NDA,And:Nda,and:nda',
                    formFieldContentSpecialCharReplaceWithUniCodeKeywords: "':α;,:β",
                    claimUploadDocumentFeatureEnabled: true,
                    claimSecureMessagingFeatureEnabled: true,
                    claimDocumentHistoryFeatureEnabled: true,
                    claimRelatedDocumentFeatureEnabled: true,
                    claimBenefitPaymentsFeatureEnabled: true,
                    claimHealthCareBenefitsFeatureEnabled: true,
                    claimNonHealthCareBenefitsFeatureEnabled: true,
                    claimSummariesFeatureEnabled: true,
                    claimEnrollmentFeatureEnabled: true,
                    claimAppealsFeatureEnabled: true
                },
                directDepositDisplayFlag_WSIB: true
            },
            jsonrpc: '2.0'
        };
        const emptyData = {
            id: 'edac3044-af8f-46d2-aa44-7e86af0edd48_1',
            result: {
                items: [],
                maxNumberOfResults: 0,
                claimArchived_WSIB: false,
                claimFeatures_WSIB: {
                    formFieldContentDecodedEncodedKeywords: 'or:ro,OR:RO,Or:Ro,AND:NDA,And:Nda,and:nda,not:otn,NOT:OTN,Not:otN',
                    formFieldContentSpecialCharReplaceWithUniCodeKeywords: "':α;,:β",
                    claimUploadDocumentFeatureEnabled: true,
                    claimSecureMessagingFeatureEnabled: true,
                    claimDocumentHistoryFeatureEnabled: true,
                    claimRelatedDocumentFeatureEnabled: true,
                    claimBenefitPaymentsFeatureEnabled: true,
                    claimHealthCareBenefitsFeatureEnabled: true,
                    claimNonHealthCareBenefitsFeatureEnabled: true,
                    claimSummariesFeatureEnabled: true,
                    claimEnrollmentFeatureEnabled: true,
                    claimAppealsFeatureEnabled: true
                },
                directDepositDisplayFlag_WSIB: false
            },
            jsonrpc: '2.0'
        };
        let data = okData;
        if (sessionStorage.getItem('mockclaims') === 'empty') {
            data = emptyData;
        }
        return Promise.resolve(data.result);
    }

    static cancelTheClaimApplication(query, offset, additionalHeaders = {}) {
        const data = {
            id: '80b83104-2881-47b2-8e23-b79820fb0b2b_2',
            result: {
            },
            jsonrpc: '2.0'
        };
        return Promise.resolve(data.result);
    }

    static checkClaimNumberStatus(query, offset, additionalHeaders = {}) {
        const data = {
            id: '80b83104-2881-47b2-8e23-b79820fb0b2b_2',
            result: {
                cumulativeFailureIn24Hours: 2,
                status: 'Started',
                pinRequestDate: 'Mon Jun 09 10:39:48 EDT 2025',
            },
            jsonrpc: '2.0'
        };
        return Promise.resolve(data.result);
    }


    static getNotifications(additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('claim'),
        //     'getClaimSummaries_WSIB', [query, offset], this.getAuthHeader());
        const data = {
            id: '9d3705be-d10d-47ff-99dd-50ab1b730052_1',
            result: [
                {
                    publicID: 'cc:101',
                    read: 'true',
                    shortMessage: 'Short Message Template',
                    longMessage: 'Long Message Template',
                    externalHyperLink: 'https://someexternallinkurl/'
                }
            ],
            jsonrpc: '2.0'
        };
        return Promise.resolve(data.result);
    }

    static getUserInfo() {
        const data = {
            id: '9d3705be-d10d-47ff-99dd-50ab1b730052_1',
            result: [
                {
                    email: 'santhosam.m@accenture.com',
                    date: '2017-12-30T03:19:17Z',
                }
            ],
            jsonrpc: '2.0'
        };
        return Promise.resolve(data.result);
    }

    /*
     * @param {string} params
     * @returns claim Details
     * fetch direct deposit account status
     */
    static getDirectDepositAccountStatus(params, additionalHeaders = {}) {
        //   return JsonRPCService.send(getProxiedServiceUrl('directDeposit'),
        //       'getUserAccountStatus', [params], this.getAuthHeader());
        const accountStatusUnlocked = {
            id: '8958076d-f08c-4db4-9bbc-b649dbbb8b5b_2',
            result: 'true',
            jsonrpc: '2.0'
        };
        const accountStatusLocked = {
            id: '8958076d-f08c-4db4-9bbc-b649dbbb8b5b_2',
            result: 'false',
            jsonrpc: '2.0'
        };

        let ret = accountStatusUnlocked;
        if (sessionStorage.getItem('mocklocked') === 'true') {
            ret = accountStatusLocked;
        }
        return Promise.resolve(ret.result);
    }

    static messageCount(params, additionalHeaders = {}) {
        //     return JsonRPCService.send(getProxiedServiceUrl('customerMessage'),
        //         'getNewMessageCount', [params], this.getAuthHeader());
        const newMessageRet = {
            id: '880a76d0-3a2c-4fb8-9b7c-542578450896_6',
            result: 0,
            jsonrpc: '2.0'
        };

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(newMessageRet.result);
            }, 1000);
        });
    }

    static getMessageList(params, additionalHeaders = {}) {
        //    return JsonRPCService.send(getProxiedServiceUrl('customerMessage'),
        //        'getMessagesForCustomer', [params], this.getAuthHeader());
        const messageRet = {
            id: '880a76d0-3a2c-4fb8-9b7c-542578450896_7',
            result: {
                customerMessages: {
                    customerMessageDetail: [
                        {
                            body: '123',
                            publicID: 'cc:292201',
                            groupID: '400000000107095',
                            messageType: 'Question',
                            sendDate: '12 Mar 2025 09:38 EDT',
                            messagingSubject: 'payments',
                            sentFromPortal: true,
                            portalUserDisplayName: 'john test'
                        },
                        {
                            body: 'hg',
                            publicID: 'cc:290420',
                            groupID: '400000000107017',
                            messageType: 'Question',
                            sendDate: '29 Jan 2025 15:41 EST',
                            messagingSubject: 'information',
                            sentFromPortal: true,
                            portalUserDisplayName: 'john test'
                        },
                        {
                            body: 'ceci est un exemple de message',
                            publicID: 'cc:285405',
                            groupID: '400000000106647',
                            messageType: 'Question',
                            sendDate: '27 Aug 2024 10:34 EDT',
                            messagingSubject: 'payments',
                            sentFromPortal: false,
                            portalUserDisplayName: 'john test'
                        }
                    ]
                }
            },
            jsonrpc: '2.0'
        };
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(messageRet.result);
            }, 1000);
        });
    }

    /*
     * @param {string} params
     * save message
     */
    static saveMessage(params, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('customerMessage'),
        //     'saveMessage', [params], this.getAuthHeader());
        const messageRet = {
            id: '0312e41b-3041-4799-aef4-468b8ffc4449_22',
            result: [
                '30415081',
            ],
            jsonrpc: '2.0'
        };
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(messageRet.result);
            }, 1000);
        });
    }

    /*
     * @param {string} params
     * get Message Thread
     */
    static getMessageThread(params, additionalHeaders = {}) {
        //    return JsonRPCService.send(getProxiedServiceUrl('customerMessage'),
        //        'getMessageThread', params, this.getAuthHeader());
        const messageRet = {
            id: '00f835a5-fd5d-470f-a9bc-a9afd1067ead_8',
            result: {
                customerMessages: {
                    customerMessageDetail: [
                        {
                            body: 'test',
                            publicID: 'cc:293507',
                            groupID: '400000000107180',
                            messageType: 'Question',
                            sendDate: '06 May 2025 10:32 EDT',
                            messagingSubject: 'information',
                            sentFromPortal: false,
                            portalUserDisplayName: 'john test'
                        }
                    ]
                }
            },
            jsonrpc: '2.0'
        };
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(messageRet.result);
            }, 1000);
        });
    }

    // test cases:
    // input 1900/01 to turn failure.
    // otherwise, return success
    static directDepositVerifyDob(claimNumber, month, year, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('directDeposit'),
        //    'verifyDob', [claimNumber, month, year], this.getAuthHeader());
        let ret = { result: 'true' };

        if (year === '1900' && month === '01') {
            ret = { result: 'false' };
        }
        return Promise.resolve(ret.result);
    }

    // this mock method does not handle server response, as the response does not
    // matter for client. Instead, the mock method set the session storage item to
    // the account is locked by server
    static directDepositFailureToServer(claimNumber, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('directDeposit'),
        //    'createHistoryForAuthFailure', [claimNumber], this.getAuthHeader());
        sessionStorage.setItem('mocklocked', 'true');
        return Promise.resolve({});
        // return Promise.reject(new Error('reqeust failed'));
    }

    // all input are valid, except transit 000 and institution 00000
    static directDepositVerifyBankInfo(serviceName, transitNumber, institutionNumber, additionalHeaders = {}) {
        let ret = {
            id: 'cbd4d7db-6974-4f2c-b16d-61d269379f0a_1',
            result: 'CANADIAN IMPERIAL BANK OF COMMERCE\nYONGE & BLOOR\n2 BLOOR ST. W.\nTORONTO, ON, M4W 3E2',
            jsonrpc: '2.0'
        };

        if (institutionNumber === '000' && transitNumber === '00000') {
            ret = {
                id: '6845232f-5543-480c-8b27-a3f31ddefed3_1',
                result: {},
                jsonrpc: '2.0'
            };
        }
        return Promise.resolve(ret.result);
    }

    static updateDirectDepositInfo(bankinformation, additionalHeaders = {}) {
        // return JsonRPCService.send(getProxiedServiceUrl('directDeposit'),
        //    'updateDirectDepositBankInfo', [bankinformation], this.getAuthHeader());

        // sample response
        // {"id":"7026aeec-ca5a-4917-81a2-80c7ce9c71d8_12","result":"true","jsonrpc":"2.0"}
        let ret = { result: 'true' };

        if (bankinformation.wsibbankNumber === '0000' && bankinformation.wsibbranchNumber === '00000') {
            ret = { result: 'false' };
        } else {
            sessionStorage.setItem('mockbankinfo', 'true');
        }
        return Promise.resolve(ret.result);
    }
}

// to enable mock data, in sessionStorage, set mockdata to 'true'.
// hardcode below mockData variable to true to avoid the above step and always use mock data
// in case the service is unavailable

// const mockData = 'true'; // force to test with mockdata
 const mockData = sessionStorage.getItem('mockdata');

export default mockData === 'true' ? MockClaimService : ClaimService;
